'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { CheckCircle2, CheckIcon, Circle } from 'lucide-react';
import type { CumulativeType } from '@/modules/finances/lib/expenses-metric-chart-search-params';
import { CUMULATIVE_OPTIONS } from './cumulative-options';
interface ExpensesMetricCumulativeDrawerProps {
  isCumulative: boolean;
  cumulativeType: CumulativeType;
  onToggleCumulative: () => void;
  onChangeCumulativeType: (value: CumulativeType) => void;
}
function ExpensesMetricCumulativeDrawer(t0) {
  const $ = _c(20);
  const {
    isCumulative,
    cumulativeType,
    onToggleCumulative,
    onChangeCumulativeType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Cumulative</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isCumulative && "border-primary bg-primary text-primary-foreground";
  let t3;
  if ($[1] !== t2) {
    t3 = cn("border-input dark:bg-input/30 flex size-4 shrink-0 items-center justify-center rounded-[4px] border shadow-xs", t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isCumulative) {
    t4 = isCumulative && <CheckIcon className="size-3.5" />;
    $[3] = isCumulative;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <span aria-hidden="true" className={t3}>{t4}</span>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onToggleCumulative || $[9] !== t5) {
    t6 = <button type="button" className="flex items-center justify-between px-8 py-3 text-left text-sm/5.5 font-semibold" onClick={onToggleCumulative}>{t1}{t5}</button>;
    $[8] = onToggleCumulative;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== cumulativeType || $[12] !== isCumulative || $[13] !== onChangeCumulativeType) {
    t7 = CUMULATIVE_OPTIONS.map(option => {
      const isActive = isCumulative && cumulativeType === option.value;
      return <button key={option.value} type="button" disabled={!isCumulative} className={cn("flex items-start gap-3 rounded-md border p-3 text-left transition-colors", isCumulative ? "hover:bg-accent/40 cursor-pointer" : "cursor-not-allowed opacity-50", isActive && "bg-accent border-primary/20")} onClick={() => {
        onChangeCumulativeType(option.value);
      }}><div className="text-primary mt-0.5">{isActive ? <CheckCircle2 className="size-4" /> : <Circle className="size-4" />}</div><div className="flex min-w-0 flex-1 flex-col gap-1"><span className="text-sm font-semibold">{option.label}</span><span className="text-muted-foreground text-xs leading-5">{option.description}</span></div></button>;
    });
    $[11] = cumulativeType;
    $[12] = isCumulative;
    $[13] = onChangeCumulativeType;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <div className="border-border border-t px-2 pt-2 pb-1"><div className="flex flex-col gap-2">{t7}</div></div>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="bg-popover flex flex-col rounded-md border py-1">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
export { ExpensesMetricCumulativeDrawer };